// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Vuetify from 'vuetify'
import 'vue-material-design-icons/styles.css'

import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

import { store } from './store/index.js'
import Vuex from 'vuex'
import VueTheMask from 'vue-the-mask'
import _ from 'lodash'

import ViaCep from "vue-viacep";
Vue.use(ViaCep);

import Fragment from "vue-fragment";
Vue.use(Fragment.Plugin)

var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin
Vue.use(VueCookie);

Vue.use(Vuex)
Vue.use(VueTheMask)
Vue.use(_)

import moment from 'moment'
import 'moment/locale/pt-br';

Vue.use(require('vue-moment'), {
  moment
});

import '@/components/_globals'

Vue.use(Vuetify, {
  theme: {
    "primary": "#000",
    "primary-text": "#000",
    "secondary": "#9B9B9B",
    "yellow": "#F1E41E",
    "blue": "#061D45",
    "lightblue": "#282498",
    "darkblue": "#191737",
    "lightgray": "#4E4E4E"
  }
})
import SvgIcon from './components/SvgIcon'
Vue.component('svg-icon', SvgIcon)


import settings from '@/app.settings'
Vue.prototype.$settings = settings

import strings from '@/app.strings'
Vue.prototype.$strings = strings

import jquery from 'jquery';
Vue.prototype.$jquery = jquery;

Vue.prototype.mostraMensagemBloqueio = false;
Vue.prototype.desabilitaLogin = false;

// EventBus
export const eventBus = new Vue();

// #ffb600
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js